import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  FeatureFlagDetail,
  FeatureFlagEvaluationResult,
  FeatureFlagQuery,
  FeatureFlagSaveRequest,
  PagedResult,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  queryFlags(query: FeatureFlagQuery): Observable<PagedResult<FeatureFlagDetail>> {
    return this.http.post<PagedResult<FeatureFlagDetail>>(OperationsApiRoutes.featureFlagsQuery, query, {
      context: this.quietContext,
    });
  }

  getFlag(id: string): Observable<FeatureFlagDetail> {
    return this.http.get<FeatureFlagDetail>(OperationsApiRoutes.featureFlagById(id));
  }

  createFlag(request: FeatureFlagSaveRequest): Observable<FeatureFlagDetail> {
    return this.http.post<FeatureFlagDetail>(OperationsApiRoutes.featureFlags, request);
  }

  updateFlag(id: string, request: FeatureFlagSaveRequest): Observable<FeatureFlagDetail> {
    return this.http.put<FeatureFlagDetail>(OperationsApiRoutes.featureFlagById(id), request);
  }

  enableFlag(id: string): Observable<FeatureFlagDetail> {
    return this.http.post<FeatureFlagDetail>(OperationsApiRoutes.featureFlagEnable(id), {});
  }

  disableFlag(id: string): Observable<FeatureFlagDetail> {
    return this.http.post<FeatureFlagDetail>(OperationsApiRoutes.featureFlagDisable(id), {});
  }

  deleteFlag(id: string): Observable<boolean> {
    return this.http.delete<boolean>(OperationsApiRoutes.featureFlagById(id));
  }

  evaluateFlag(name: string): Observable<FeatureFlagEvaluationResult> {
    return this.http.get<FeatureFlagEvaluationResult>(OperationsApiRoutes.featureFlagEvaluate(name));
  }
}
